module.exports = __webpack_public_path__ + "static/media/greece.a98d3e5a.png";